export default __webpack_public_path__ + "static/media/digital-empire-big-1@2x.5a2b2468.png";